class BulkOrderButtonContainer extends HTMLElement {
  constructor() {
    super();
    this.bulkOrderButtonElement = this.querySelector('.bulk-order-button-element');
    this.bulkOrderPopupElement = document.querySelector('.bulk-order-form');
    this.bodyElement = document.querySelector('body');
    this.toggleBulkOrderFormVisibility = this.toggleBulkOrderFormVisibility.bind(this);
    this.downloadCatalogueButton = document.querySelector('.download-catalogue-button');
  }

  connectedCallback() {
    if (this.bulkOrderButtonElement && this.bulkOrderPopupElement) {
      this.bulkOrderButtonElement.addEventListener('click', (event) => {
        event.preventDefault();
        this.bodyElement.classList.add('overflow-hidden');
        this.bulkOrderButtonElement?.setAttribute('aria-expanded', 'true');
        this.bulkOrderPopupElement.classList.add('show-bulk-order-popup');
      });
    }
    if(this.downloadCatalogueButton){
      this.downloadCatalogueButton.addEventListener('click', event => {
        fbq('trackCustom', 'download_catalogue');
        // Trigger LinkedIn event for catalog download
        _linkedin_partner_id = "7198604";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function(){
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })();
        window.lintrk('track', { conversion_id: 19684868 });
        console.log('Download catalog event triggered'); 
      });
    }
    document.addEventListener('keydown', this.toggleBulkOrderFormVisibility);
    document.addEventListener('click', this.toggleBulkOrderFormVisibility);
  }

  toggleBulkOrderFormVisibility(event){
    if (event.key === 'Escape' || event.target === this.bulkOrderPopupElement || event.target.closest('.bulk-order-popup__close-icon')) {
      const errormessages = document.querySelectorAll('.show-bulk-order-form-error, .bulk-order-form__error-element');
      if(errormessages.length > 0){
          errormessages.forEach(eachmessage => {
            if(eachmessage.classList.contains('show-bulk-order-form-error')){
              eachmessage.classList.remove('show-bulk-order-form-error');
            } else if(eachmessage.classList.contains('bulk-order-form__error-element')){
              eachmessage.classList.remove('bulk-order-form__error-element');
            }
        });
      }
      this.bulkOrderButtonElement?.setAttribute('aria-expanded', 'false');
      this.bulkOrderPopupElement.classList.remove('show-bulk-order-popup');
      this.bodyElement.classList.remove('overflow-hidden');
      this.bulkOrderPopupElement.querySelector('form').reset();
      const typeOfInstitutionContainer = document.querySelector('.bulk-order-form .bulk-order-form__institution-type-input-element');
      let typeOfInstitution = null;
      if(typeOfInstitutionContainer){
        typeOfInstitution = typeOfInstitutionContainer.querySelector('#typeOfInstitution');
      }
      const otherTypeOfInstitutionContainer = document.querySelector('.bulk-order-form .bulk-order-form__other-type-of-institution-element');
      let otherTypeOfInstitution = null;
      if(otherTypeOfInstitutionContainer){
        otherTypeOfInstitution = otherTypeOfInstitutionContainer.querySelector('#otherTypeOfInstitution');
      }

      if (typeOfInstitutionContainer?.classList.contains('hide-bulk-order-element')) {
        typeOfInstitutionContainer.classList.remove('hide-bulk-order-element');
        if(typeOfInstitution){
          typeOfInstitution?.setAttribute('required','');
        }
      }

      if (otherTypeOfInstitutionContainer && !otherTypeOfInstitutionContainer?.classList.contains('hide-bulk-order-element')) {
        otherTypeOfInstitutionContainer.classList.add('hide-bulk-order-element');
        if(otherTypeOfInstitution){
          otherTypeOfInstitution?.removeAttribute('required');
        }
      }
    }
  }
}
customElements.define('bulk-order-button-container', BulkOrderButtonContainer);

class BulkOrderForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.nameInput = this.querySelector('#name');
      this.emailInput = this.querySelector('#email');
      this.mobileInput = this.querySelector('#mobile');
      this.typeOfInstitution = this.querySelector('#typeOfInstitution');
      this.otherTypeOfInstitution = this.querySelector('#otherTypeOfInstitution');
      this.businessNameInput = this.querySelector('#businessName');
      this.messageInput = this.querySelector('#message');
      this.errorName = this.querySelector('.bulk-order-form__name-error');
      this.errorMobile = this.querySelector('.bulk-order-form__mobile-error');
      this.errorEmail = this.querySelector('.bulk-order-form__email-error');
      this.errorOtherTypeOfInstitution = this.querySelector('.bulk-order-form__other-type-of-institution-error');
      this.attachEventListeners();
    }
  
    attachEventListeners() {
      this.nameInput.addEventListener('blur', this.validateName.bind(this));
      this.nameInput.addEventListener('input', this.validateName.bind(this));
      this.nameInput.addEventListener('paste', this.validateName.bind(this));
      this.emailInput.addEventListener('blur', this.validateEmail.bind(this));
      this.mobileInput.addEventListener('input', this.validateMobileInput.bind(this));
      this.mobileInput.addEventListener('blur', this.validateMobileLength.bind(this));
      this.typeOfInstitution.addEventListener('change', this.validateInstitutionType.bind(this));
      if(this.otherTypeOfInstitution){
        this.otherTypeOfInstitution.addEventListener('blur', this.validateOtherTypeOfInstitution.bind(this));
      }
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  
    toggleError(inputElement, errorElement, show, message = '') {
      if (show) {
        inputElement.classList.add('bulk-order-form__error-element');
        errorElement.classList.add('show-bulk-order-form-error');
        errorElement.textContent = message;
      } else {
        inputElement.classList.remove('bulk-order-form__error-element');
        errorElement.classList.remove('show-bulk-order-form-error');
        errorElement.textContent = '';
      }
    }
  
    validateName(event) {
      const value = event.target.value.trim();
      const isValid = /^[a-zA-Z ]+$/.test(value);
      this.toggleError(this.nameInput, this.errorName, !isValid, this.dataset.nameerror);
      event.target.value = isValid ? value : '';
    }
  
    validateMobileInput(event) {
      let digits = event.target.value.replace(/\D/g, '');
      if (digits.length > 10) {
        digits = digits.slice(0, 10);
      }
      event.target.value = digits;
    }

    validateMobileLength(event) {
      const mobileNumber = this.mobileInput.value;
      const mobilePattern = /^[6-9]\d{9}$/;
      const isValid = mobilePattern.test(mobileNumber);
      this.toggleError(this.mobileInput, this.errorMobile, !isValid, this.dataset.mobileerror);
      return isValid;
    }
  
    validateEmail(event) {
      const email = this.emailInput.value.trim();
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const hasConsecutiveDots = /\.\./.test(email);
      const isValid = emailRegex.test(email) && !hasConsecutiveDots;
      this.toggleError(this.emailInput, this.errorEmail, !isValid, this.dataset.emailerror);
      return isValid;
    }

    validateInstitutionType() {
      const typeOfInstitutionContainer = this.querySelector('.bulk-order-form__institution-type-input-element');
      const otherTypeOfInstitutionContainer = this.querySelector('.bulk-order-form__other-type-of-institution-element');
      const options = Array.from(this.typeOfInstitution.options);
      const targetText = this.dataset.typeofinstitution?.trim().toLowerCase();

      options.forEach(option => {
        if (option.textContent.trim().toLowerCase() === targetText) {
          option?.setAttribute('disabled', 'true');
        }
      });
      const selectedValue = this.typeOfInstitution.value;
      const isOtherSelected = selectedValue.toLowerCase() === 'other';
      const errorElement = this.querySelector('.bulk-order-form__institution-type-error');
    
      let isValid = true;
    
      if (!selectedValue || selectedValue.trim() === this.dataset.typeofinstitution) {
        isValid = false;
      }
    
      this.toggleError(this.typeOfInstitution, errorElement, !isValid, this.dataset.institutionerror || 'Please select a valid institution type.');
    
      if (isOtherSelected && this.otherTypeOfInstitution) {
        if(!typeOfInstitutionContainer?.classList.contains("hide-bulk-order-element")){
          typeOfInstitutionContainer.classList.add('hide-bulk-order-element');
          this.typeOfInstitution?.removeAttribute('required');
        }
        if(otherTypeOfInstitutionContainer?.classList.contains("hide-bulk-order-element")){
          otherTypeOfInstitutionContainer.classList.remove('hide-bulk-order-element');
          this.otherTypeOfInstitution?.setAttribute('required','');
        }
      } else {
        if(otherTypeOfInstitutionContainer && !otherTypeOfInstitutionContainer.classList.contains("hide-bulk-order-element")){
          otherTypeOfInstitutionContainer.classList.add('hide-bulk-order-element');
          this.otherTypeOfInstitution?.removeAttribute('required');
          this.typeOfInstitution?.setAttribute('required','');
        }
        if(this.otherTypeOfInstitution){ 
          this.otherTypeOfInstitution.value = ''; // clear previous input
        }
      }
    
      return isValid;
    }

    validateOtherTypeOfInstitution() {
        const value = this.otherTypeOfInstitution?.value.trim();
        const isValid = /^[a-zA-Z ]{2,}$/.test(value); // basic name validation
        this.toggleError(this.otherTypeOfInstitution, this.errorOtherTypeOfInstitution, !isValid, this.dataset.othertypeerror || 'Please enter a valid institution name.');
        return isValid;
    }
    

    getValidData(data){
      if(data === ''){
        return 'N/A';
      } else {
        return data;
      }
    }
  
    async handleSubmit(event) {
      event.preventDefault();
  
      const name = this.nameInput.value.trim();
      const email = this.emailInput.value.trim();
      const mobile = this.mobileInput.value.trim();
      let typeOfInstitution = this.typeOfInstitution.value.trim();
      const businessName = this.businessNameInput.value.trim();
      const message = this.messageInput.value.trim();
  
      const isNameValid = name.length > 0 && /^[a-zA-Z ]+$/.test(name);
      const isMobileValid = this.validateMobileLength();
      const isEmailValid = this.validateEmail(); // this also shows error if invalid
      const isInstitutionValid = this.validateInstitutionType();
      const isOtherSelected = typeOfInstitution.toLowerCase() === 'other';
      let isOtherValid = true;
      if (isOtherSelected) {
        isOtherValid = this.validateOtherTypeOfInstitution();
        typeOfInstitution = this.otherTypeOfInstitution.value.trim(); // override value with input
      }

  
      this.toggleError(this.nameInput,this.errorName, !isNameValid, this.dataset.nameerror);
      this.toggleError(this.mobileInput,this.errorMobile, !isMobileValid, this.dataset.mobileerror);
  
      if (!isNameValid || !isMobileValid || !isEmailValid || !isInstitutionValid || !isOtherValid) return;
  
      const formData = new FormData();
      formData.append('Name', name);
      formData.append('Email', email);
      formData.append('Mobile', mobile);
      formData.append('Country', typeOfInstitution);
      formData.append('Region', businessName);
      formData.append('Purpose of Buying', message);
      const utmData = sessionStorage.getItem('utmData');
      if (utmData) {
        try {
          const parsed = JSON.parse(utmData);
          if (parsed.utm_source) {
            formData.append('Source', parsed.utm_source);
          }
          if (parsed.utm_campaign) {
            formData.append('Campaign', parsed.utm_campaign);
          }
          if (parsed.utm_content) {
            formData.append('Content', parsed.utm_content);
          }
        } catch (error) {
          console.warn('Failed to parse UTM data:', error);
        }
      }
      const bulkOrderFormData = {
        'Name': this.getValidData(name),
        'Email': this.getValidData(email),
        'Mobile': this.getValidData(mobile),
        'Type of Institution': this.getValidData(typeOfInstitution),
        'Business name': this.getValidData(businessName),
        'Message': this.getValidData(message)
      }
  
      const submitButton = this.form.querySelector('.bulk-order-form__submit-button');
      const submitButtontext = this.form.querySelector('.bulk-order-form__submit-button-text');
      const thankyouNoteElement = this.querySelector('.bulk-order-form__thankyou-note-container');
      submitButton?.setAttribute('disabled', 'true');
      submitButtontext.classList.add('hide-bulk-order-element');
      submitButton.classList.add('bulk-order-loading');
  
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: formData,
        });
  
        if (response.ok) {
          try {
            sessionStorage.setItem('bulkOrderFormData', JSON.stringify(bulkOrderFormData));
            const bulkOrderCtasPayload = {
              "login_status": window.loginStatus,
              "user_email": window.customerEmail,
              "user_phone_number": window.customerPhone
            };
            clevertap.event.push('form_submit_BO', bulkOrderCtasPayload);
          } catch (error) {
            console.error('Failed to save form data to sessionStorage:', error);
          }
          const thankYouPageUrl = this.dataset.thankYouPageUrl;
          if(thankYouPageUrl && thankYouPageUrl.trim()) {
            window.location.href = thankYouPageUrl;
          } else {
           console.warn('Thank you page URL not configured');
          }
          // Reset institution type visibility
          const typeOfInstitutionContainer = this.querySelector('.bulk-order-form__institution-type-input-element');
          const otherTypeOfInstitutionContainer = this.querySelector('.bulk-order-form__other-type-of-institution-element');

          if (typeOfInstitutionContainer?.classList.contains('hide-bulk-order-element')) {
            typeOfInstitutionContainer.classList.remove('hide-bulk-order-element');
            this.typeOfInstitution?.setAttribute('required','');
          }

          if (otherTypeOfInstitutionContainer && !otherTypeOfInstitutionContainer?.classList.contains('hide-bulk-order-element')) {
            otherTypeOfInstitutionContainer.classList.add('hide-bulk-order-element');
            this.otherTypeOfInstitution?.removeAttribute('required');
          }
          const bulkOrderPopupElement = document.querySelector('.bulk-order-form');
          const bodyElement = document.querySelector('body');
          const bulkOrderFormContainer = this.querySelector('.bulk-order-form-and-heading-container');
          if(submitButton){
            submitButton.classList.remove('bulk-order-loading');
            submitButton?.removeAttribute('disabled');
          }
          if(submitButtontext) {
            submitButtontext.classList.remove('hide-bulk-order-element');
          }
        }
        // Trigger LinkedIn event
        _linkedin_partner_id = "7198604";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function(){
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
        })();
        window.lintrk('track', { conversion_id: 19684852 });
        console.log('Bulk leads submit event triggered');    
        
      } catch (error) {
        console.error('Error occurred during form submission:', error);
      } 
    }
  }
  customElements.define('bulk-order-form', BulkOrderForm);

